import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { replaceTermsTillDate } from '@/modules/promo';
import { useValidDate } from '@/modules/promo/hooks/useValidDateFromQuery';
import { ScTermsAndConditions } from './styled';

interface Props {
  title: string;
  translation: string;
  validDate?: string;
}

export const TermsAndConditions = ({
  title,
  translation,
  validDate,
}: Props) => {
  const { t } = useTranslation(translation);

  const [isOpen, setIsOpen] = useState(false);
  const validDateFromQuery = useValidDate(validDate);

  return (
    <ScTermsAndConditions isOpen={isOpen}>
      <div className="terms__title" onClick={() => setIsOpen((prev) => !prev)}>
        <span>{title}</span>
        <img alt="Arrow" src="/images/arrow.svg" />
      </div>
      <div className="terms">
        <div className="terms-content">
          <ol>
            {replaceTermsTillDate(
              Object.values(
                t('termsContent', {
                  returnObjects: true,
                  ...(validDateFromQuery ? { date: validDateFromQuery } : {}),
                }) as Record<string, string>
              ),
              validDateFromQuery
            ).map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ol>
        </div>
      </div>
    </ScTermsAndConditions>
  );
};
